import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://royal-falcon-backend.onrender.com/",
    // baseUrl: "http://localhost:5000",
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");

      if (token) {
        headers.set("authorization", `${token}`);
      }

      return headers;
    },
  }),
  refetchOnFocus: true, // Enables refetching when the app regains focus
  refetchOnReconnect: true, // Ensures data refetch on reconnection
  keepUnusedDataFor: 0, // Forces refetching each time the query is executed
  tagTypes: [
    "Login",
    "Bookings",
    "VehileCategories",
    "Vehicle",
    "Driver",
    "Homepage",
    "Investor",
    "Customer",
    "Supplier",
    "VehicleName",
    "VehicleOwnership",
  ],
  endpoints: (builder) => ({
    // your endpoint here
  }),
});
